import styled from "styled-components";
import { responsive } from "theme/responsive";

export const LayoutWrapper = styled.div`
   width: 100%;
   display: grid;
   grid-template-columns: repeat(2, 1fr);

   ${responsive("$medium")`
   grid-template-columns: repeat(1, 1fr);

   .hidden {
      display: none
   }
`}
`;

export const SignUpImage = styled.div`
   background-color: rgba(81, 74, 102, 0.76);
   background-position: center;
   background-blend-mode: darken;
   background-repeat: no-repeat;
   background-size: cover;
   background-image: url("/images/signup.png");
   position: fixed;
   left: 0;
   width: 50%;
   height: 100vh;
   display: flex;
   align-items: center;
   color: #fff;
   padding: 0 5%;

   ${responsive("$medium")`
      display: none  
   `};

   h1 {
      font-size: 40px;
      font-weight: bolder;
      line-height: 2;
   }

   p {
      font-size: 20px;
   }

   ul {
      margin-top: 3em;
      max-width: 500px;
      list-style: none;
      list-style-position: inside;

      li {
         line-height: 1.5;
         margin-bottom: 20px;
         display: flex;
         justify-content: flex-start;
         align-items: flex-start;
         gap: 1em;
      }
   }
`;

export const FormDiv = styled.div`
   display: flex;
   align-items: center;
   padding: 0 5%;
   transition: opacity 3s;

   .welcome-banner {
      width: 80%;

      background-color: #f7f7f7;
      border: 1px solid #7211d4;
      color: #7211d4;
      padding: 30px;
      border-radius: 10px;
      .heading {
         font-weight: bold;
         margin-bottom: 10px;
      }
      .body {
         text-align: justify;
      }
   }

   .overflow {
      margin: 3em 0;
      position: relative;

      .brand-wrapper {
         position: absolute;
         top: -50px;
         left: -2.1%;
      }

      .back {
         position: absolute;
         top: 5%;
         right: 5%;
         display: flex;
         align-items: center;
         cursor: pointer;
         gap: 0.5em;
         border: none;
         outline: none;
         background: transparent;

         &:hover {
            opacity: 0.5;
         }
      }
   }

   form {
      max-width: 570px;
      margin-top: 3em;
   }

   .base {
      margin-top: 4em;

      small {
         font-weight: bold;
      }
      p {
         color: #010947;
         margin: 0.75em 0;
      }
   }

   .info {
      h2 {
         color: #333333;
         max-width: 590px;
      }
      p {
         color: #010947;
         line-height: 2;
         margin: 0.75em 0;
         font-size: 16px;
         max-width: 500px;
         font-weight: light;
      }
   }
`;

export const TC = styled.div`
    display: flex;
    justify-content: flex-start;
    gap: 1em;

    a {
        padding: 0 .3em;
        color: #7211d4;
        text-decoration: none;
    }

   input {
        accent-color: #7211d4;
        margin-top: .4em;
      }
   }
`;

export const PaymentWrapper = styled.div`
   margin-bottom: 2em;
   display: flex;
   gap: 2em;
   align-items: center;
`;
